// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
} from './client';
import { client } from './client.gen';
import type {
  ActivityDetailsbyactivityIdData,
  ActivityDetailsbyactivityIdResponses,
  ActivitylogsbyactivityIdData,
  ActivitylogsbyactivityIdResponses,
  AddaNewFolderPermissionData,
  AddaNewFolderPermissionResponses,
  AddattachmentsData,
  AddattachmentsResponses,
  AddCompanyEmailDomainsData,
  AddCompanyEmailDomainsResponses,
  AddfilesData,
  AddfilesResponses,
  AddInviteUserstoprojectData,
  AddInviteUserstoprojectResponses,
  AddobjectstoTagData,
  AddobjectstoTagResponses,
  AddReactionToCommentData,
  AddReactionToCommentErrors,
  AddReactionToCommentResponses,
  AddUserstoCompanyData,
  AddUserstoCompanyResponses,
  AdduserstogroupData,
  AdduserstogroupResponses,
  BulkcreateobjectlinksData,
  BulkcreateobjectlinksResponses,
  CheckinFileData,
  CheckinFileResponses,
  CheckoutFileData,
  CheckoutFileResponses,
  CloneProjectData,
  CloneProjectResponses,
  CommitFileUploadData,
  CommitFileUploadErrors,
  CommitFileUploadResponses,
  CompleteMultipartFileUploadData,
  CompleteMultipartFileUploadErrors,
  CompleteMultipartFileUploadResponses,
  Createa2dViewMultipartData,
  Createa2dViewMultipartResponses,
  CreateAlignmentData,
  CreateAlignmentResponses,
  CreatealignmentwithmatrixData,
  CreatealignmentwithmatrixResponses,
  CreateaNew2dViewData,
  CreateaNew2dViewResponses,
  CreateaNewClashData,
  CreateaNewClashResponses,
  CreateaNewCommentData,
  CreateaNewCommentResponses,
  CreateaNewFolderData,
  CreateaNewFolderResponses,
  CreateaNewGroupData,
  CreateaNewGroupResponses,
  CreateaNewProjectData,
  CreateaNewProjectResponses,
  CreateaNewReleaseData,
  CreateaNewReleaseResponses,
  CreateaNewShareData,
  CreateaNewShareResponses,
  CreateaNewToDoData,
  CreateaNewToDoResponses,
  CreateaViewGroupData,
  CreateaViewGroupResponses,
  CreateMarkupsData,
  CreateMarkupsResponses,
  CreateNewExportRequestData,
  CreateNewExportRequestResponses,
  CreateobjectlinkData,
  CreateobjectlinkResponses,
  CreateSectionPlaneData,
  CreateSectionPlaneResponses,
  CreateTagData,
  CreateTagResponses,
  CreateViewData,
  CreateViewResponses,
  CreateViewWithThumbnailData,
  CreateViewWithThumbnailResponses,
  Delete2dViewData,
  Delete2dViewResponses,
  DeletealignmentData,
  DeletealignmentResponses,
  DeleteaobjectlinkData,
  DeleteaobjectlinkResponses,
  DeleteClashData,
  DeleteClashResponses,
  DeleteCommentData,
  DeleteCommentResponses,
  DeleteFileData,
  DeleteFileResponses,
  DeleteFolder2Data,
  DeleteFolder2Errors,
  DeleteFolder2Responses,
  DeleteFolderData,
  DeleteFolderResponses,
  DeleteGroupData,
  DeleteGroupResponses,
  DeleteMarkupData,
  DeleteMarkupResponses,
  DeleteProjectData,
  DeleteProjectResponses,
  DeleteReactionToCommentData,
  DeleteReactionToCommentResponses,
  DeleteReleaseData,
  DeleteReleaseResponses,
  DeleteRemoveattachmentsData,
  DeleteRemoveattachmentsResponses,
  DeleteReservedViewDataData,
  DeleteReservedViewDataErrors,
  DeleteReservedViewDataResponses,
  DeleteSectionBoxData,
  DeleteSectionBoxResponses,
  DeleteSectionPlaneData,
  DeleteSectionPlaneResponses,
  DeleteShareData,
  DeleteShareResponses,
  DeleteTagData,
  DeleteTagResponses,
  DeleteToDoData,
  DeleteToDoResponses,
  DeleteusersfromgroupData,
  DeleteusersfromgroupResponses,
  DeleteViewData,
  DeleteViewGroupData,
  DeleteViewGroupResponses,
  DeleteViewResponses,
  DownloadfilesinreleaseData,
  DownloadfilesinreleaseResponses,
  DownloadUrlData,
  DownloadUrlResponses,
  EditReleaseData,
  EditReleaseResponses,
  EditShareData,
  EditShareResponses,
  EditTagData,
  EditTagResponses,
  Get2dViewdetailsData,
  Get2dViewdetailsResponses,
  GetActiveFileFolderSnapshotData,
  GetActiveFileFolderSnapshotErrors,
  GetActiveFileFolderSnapshotResponses,
  GetalignmentData,
  GetalignmentResponses,
  GetAvailableRegionsData,
  GetAvailableRegionsResponses,
  GetCameraDetailsData,
  GetCameraDetailsResponses,
  GetClashDetailsData,
  GetClashDetailsResponses,
  GetCommentDetailsData,
  GetCommentDetailsResponses,
  GetCompanyDetailsData,
  GetCompanyDetailsResponses,
  GetExportdetailsData,
  GetExportDetailsData,
  GetExportdetailsResponses,
  GetExportDetailsResponses,
  GetFileDetailsData,
  GetFileDetailsErrors,
  GetFileDetailsResponses,
  GetFileFolderDetailsByNameData,
  GetFileFolderDetailsByNameErrors,
  GetFileFolderDetailsByNameResponses,
  GetFilePermissionsData,
  GetFilePermissionsErrors,
  GetFilePermissionsResponses,
  GetFileUploadDetailsData,
  GetFileUploadDetailsErrors,
  GetFileUploadDetailsResponses,
  GetFileUploadStatusData,
  GetFileUploadStatusErrors,
  GetFileUploadStatusResponses,
  GetFolderDeletionJobStatusData,
  GetFolderDeletionJobStatusErrors,
  GetFolderDeletionJobStatusResponses,
  GetFolderDetailsData,
  GetFolderDetailsErrors,
  GetFolderDetailsResponses,
  GetFolderPermissions2Data,
  GetFolderPermissions2Responses,
  GetFolderPermissionsData,
  GetFolderPermissionsErrors,
  GetFolderPermissionsResponses,
  GetGroupDetailsData,
  GetGroupDetailsResponses,
  GetListallattachmentsData,
  GetListallattachmentsResponses,
  GetPresentationData,
  GetPresentationResponses,
  GetprocessingstatusofaFileData,
  GetprocessingstatusofaFileResponses,
  GetProjectCloneDetailsData,
  GetProjectCloneDetailsResponses,
  GetProjectDetailsData,
  GetProjectDetailsResponses,
  GetProjectlicensedetailsData,
  GetProjectlicensedetailsResponses,
  GetProjectMetricsData,
  GetProjectMetricsResponses,
  GetProjectsettingsData,
  GetProjectsettingsResponses,
  GetProjectSyncObjectsData,
  GetProjectSyncObjectsErrors,
  GetProjectSyncObjectsResponses,
  GetProjectSyncStatusData,
  GetProjectSyncStatusResponses,
  GetProjectUserDetailsData,
  GetProjectUserDetailsResponses,
  GetReleaseDetailsData,
  GetReleaseDetailsResponses,
  GetReservedViewDataData,
  GetReservedViewDataErrors,
  GetReservedViewDataResponses,
  GetSectionBoxData,
  GetSectionBoxResponses,
  GetShareDetailsData,
  GetShareDetailsResponses,
  GetShareDetailsWithAccessTokenUsingStokenData,
  GetShareDetailsWithAccessTokenUsingStokenResponses,
  GetTagDetailsData,
  GetTagDetailsResponses,
  GetToDoDetailsData,
  GetToDoDetailsResponses,
  GetUserDetailsData,
  GetUserDetailsResponses,
  GetversionsofaFileData,
  GetversionsofaFileResponses,
  GetversionsofaFolderData,
  GetversionsofaFolderResponses,
  GetViewDetailsData,
  GetViewDetailsResponses,
  GetViewGroupDetailsData,
  GetViewGroupDetailsResponses,
  GetViewImageData,
  GetViewImageResponses,
  InitiateFilePackageUploadData,
  InitiateFilePackageUploadErrors,
  InitiateFilePackageUploadResponses,
  InitiateFileUploadData,
  InitiateFileUploadErrors,
  InitiateFileUploadResponses,
  ListActivitiesofaProjectObjectData,
  ListActivitiesofaProjectObjectResponses,
  Listall2dViewsData,
  Listall2dViewsResponses,
  ListallattachmentsData,
  ListallattachmentsResponses,
  ListAllAvailableTimezonesData,
  ListAllAvailableTimezonesResponses,
  ListallClashesinaprojectData,
  ListallClashesinaprojectResponses,
  ListAllClashItemsData,
  ListAllClashItemsResponses,
  ListallCommentsData,
  ListallCommentsResponses,
  ListallfilesData,
  ListallfilesResponses,
  ListallProjectsData,
  ListAllProjectsMiniData,
  ListAllProjectsMiniResponses,
  ListallProjectsResponses,
  ListAllProjectsV21Data,
  ListAllProjectsV21Errors,
  ListAllProjectsV21Responses,
  ListallReleasesData,
  ListallReleasesResponses,
  ListAllSearchResultsData,
  ListAllSearchResultsResponses,
  ListallSharesData,
  ListallSharesResponses,
  ListAllSupportedLanguagesData,
  ListAllSupportedLanguagesResponses,
  ListallToDosData,
  ListallToDosResponses,
  ListallTodoTypesofaProjectData,
  ListallTodoTypesofaProjectResponses,
  ListallUsersinprojectData,
  ListallUsersinprojectResponses,
  ListallViewGroupsData,
  ListallViewGroupsResponses,
  ListallViewsinaprojectData,
  ListallViewsinaprojectResponses,
  ListCompaniesData,
  ListCompaniesResponses,
  ListGroupsinaprojectData,
  ListGroupsinaprojectResponses,
  ListItemsinaFolderbypathData,
  ListItemsinaFolderByPathData,
  ListItemsinaFolderByPathErrors,
  ListItemsinaFolderbypathResponses,
  ListItemsinaFolderByPathResponses,
  ListItemsinaFolderData,
  ListItemsinaFolderErrors,
  ListItemsinaFolderResponses,
  ListItemsinaFolderV21Data,
  ListItemsinaFolderV21Responses,
  ListlinkedentitiesforobjectsData,
  ListlinkedentitiesforobjectsResponses,
  ListlinksforthegiventargetentityData,
  ListlinksforthegiventargetentityResponses,
  ListMarkupsData,
  ListMarkupsResponses,
  ListobjectsinaTagData,
  ListobjectsinaTagResponses,
  ListReactionsToCommentData,
  ListReactionsToCommentResponses,
  ListrolesavailableinprojectData,
  ListrolesavailableinprojectResponses,
  ListSectionPlanesData,
  ListSectionPlanesResponses,
  ListSupported2D3dSpatialfileformatsData,
  ListSupported2D3dSpatialfileformatsResponses,
  ListTagsinaprojectData,
  ListTagsinaprojectResponses,
  ListUserLicensesData,
  ListUserLicensesResponses,
  ListUsersinaCompanyData,
  ListUsersinaCompanyResponses,
  ListUsersinaGroupData,
  ListUsersinaGroupResponses,
  PatchFilePermissionsData,
  PatchFilePermissionsErrors,
  PatchFilePermissionsResponses,
  PatchFolderPermissionsData,
  PatchFolderPermissionsErrors,
  PatchFolderPermissionsResponses,
  PostActivitiesListData,
  PostActivitiesListResponses,
  PostAddattachmentsData,
  PostAddattachmentsResponses,
  PostCreateanewexportRequestData,
  PostCreateanewexportRequestResponses,
  PutReservedViewDataData,
  PutReservedViewDataErrors,
  PutReservedViewDataResponses,
  RemoveanyexistingFolderPermissionData,
  RemoveanyexistingFolderPermissionResponses,
  RemoveattachmentsData,
  RemoveattachmentsResponses,
  RemoveCompanyEmailDomainsData,
  RemoveCompanyEmailDomainsResponses,
  RemovefilesData,
  RemovefilesResponses,
  RemoveobjectsfromTagData,
  RemoveobjectsfromTagResponses,
  RemoveuserData,
  RemoveUserfromtheCompanyData,
  RemoveUserfromtheCompanyResponses,
  RemoveuserResponses,
  RemoveUsersfromCompanyData,
  RemoveUsersfromCompanyResponses,
  RenameGroupData,
  RenameGroupResponses,
  RequestProjectAccessData,
  RequestProjectAccessResponses,
  Update2dViewData,
  Update2dViewMultipartData,
  Update2dViewMultipartResponses,
  Update2dViewResponses,
  UpdateCameraData,
  UpdateCameraResponses,
  UpdateClashData,
  UpdateClashResponses,
  UpdateCommentData,
  UpdateCommentResponses,
  UpdateCompanyData,
  UpdateCompanyResponses,
  UpdateexistingFolderPermissionData,
  UpdateexistingFolderPermissionResponses,
  UpdateFileDetailsData,
  UpdateFileDetailsResponses,
  UpdateFolderData,
  UpdateFolderErrors,
  UpdateFolderResponses,
  UpdateMarkupData,
  UpdateMarkupResponses,
  UpdateobjectlinksData,
  UpdateobjectlinksResponses,
  UpdatePresentationData,
  UpdatePresentationResponses,
  UpdateProjectData,
  UpdateProjectLicenseDetailsData,
  UpdateProjectLicenseDetailsResponses,
  UpdateProjectResponses,
  UpdateProjectSettingsData,
  UpdateProjectSettingsResponses,
  UpdateSectionBoxData,
  UpdateSectionBoxResponses,
  UpdateSectionPlaneData,
  UpdateSectionPlaneResponses,
  UpdateToDoData,
  UpdateToDoResponses,
  UpdateUserDetailsData,
  UpdateUserDetailsResponses,
  UpdateUserintheCompanyData,
  UpdateUserintheCompanyResponses,
  UpdateUserroleData,
  UpdateUserroleResponses,
  UpdateViewData,
  UpdateViewGroupDetailsData,
  UpdateViewGroupDetailsResponses,
  UpdateViewResponses,
  UpdateViewWithThumbnailData,
  UpdateViewWithThumbnailResponses,
  UploadCompanyImageData,
  UploadCompanyImageResponses,
  UploadFileData,
  UploadFileResponses,
  UploadProjectImageData,
  UploadProjectImageResponses,
  UploadViewThumbnailImageData,
  UploadViewThumbnailImageResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * List Items in a Folder by Path
 *
 * List Items in a Folder by Path
 * API to list all items in a folder specified by a path within a project, with cursor-based pagination and optional field selection.
 *
 * The `links.next.href` property in the response contains the URL to the next page of results. If there are no more results, the `links.next.href` property is not present in the response.
 * The requester is expected to call `links.next.href` to fetch the rest of the resources, if `links.next.href` is present in the response.
 *
 * **Pagination** : Uses cursor-based pagination with `skipToken` and `pageSize` parameters.
 * **Field Selection**: Use the `fields` parameter to include optional fields information.
 * **Sorting** : Supports composed order sorting with `sort` parameter.
 * **Path-based Access**: Specify folder location using relative path within a project.
 *
 */
export const listItemsinaFolderByPath = <ThrowOnError extends boolean = false>(
  options: Options<ListItemsinaFolderByPathData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListItemsinaFolderByPathResponses,
    ListItemsinaFolderByPathErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/2.1/folders/by_path',
    ...options,
  });

/**
 * List Items in a Folder
 *
 * List Items in a Folder
 * API to list all items in a folder with cursor-based pagination and optional field selection.
 *
 * The `links.next.href` property in the response contains the URL to the next page of results. If there are no more results, the `links.next.href` property is not present in the response.
 * The requester is expected to call `links.next.href` to fetch the rest of the resources,if `links.next.href` is present in the response.
 *
 * **Pagination** : Uses cursor-based pagination with `skipToken` and `pageSize` parameters.
 * **Field Selection**: Use the `fields` parameter to include optional fields information.
 * **Sorting** : Supports composed order sorting with `sort` parameter.
 *
 */
export const listItemsinaFolder = <ThrowOnError extends boolean = false>(
  options: Options<ListItemsinaFolderData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListItemsinaFolderResponses,
    ListItemsinaFolderErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/2.1/folders/{folderId}/items',
    ...options,
  });

/**
 * List all Projects (v2.1)
 *
 * API to list all projects for the user with cursor-based pagination and optional field selection.
 *
 * The `links.next.href` property in the response contains the URL to the next page of results. If there are no more results, the `links.next.href` property is not present in the response.
 * Server may return response with `links.next.href` property even if the response contains no / lesser than requested(pageSize) items.
 * Server may return less items than `pageSize` requested (or even zero). It could happen e.g. if resources requested are too large to fit into a single response
 * or if some (or all `pageSize` requested) resources are not accessible to the requester. In this case requester is expected to call `links.next.href` to fetch the rest of the resources,if `links.next.href` is present in the response.
 * In extreme cases response could be empty with the `links.next.href` present, it means that all resources on the current page is not accessible to the requester.
 *
 * **Pagination**: Uses cursor-based pagination with `skipToken` and `pageSize` parameters.
 * **Field Selection**: Use the `fields` parameter to include optional license and description information.
 * **Sorting**: Supports single-field sorting with `sortBy` parameter.
 *
 */
export const listAllProjectsV21 = <ThrowOnError extends boolean = false>(
  options?: Options<ListAllProjectsV21Data, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListAllProjectsV21Responses,
    ListAllProjectsV21Errors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/2.1/projects',
    ...options,
  });

/**
 * List Activities of a Project / Object
 *
 * API to list the activities in a project / specific object
 */
export const listActivitiesofaProjectObject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListActivitiesofaProjectObjectData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListActivitiesofaProjectObjectResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activities',
    ...options,
  });

/**
 * Create a new export Request
 *
 * This API is used to create export Request for activities in a project.
 */
export const postCreateanewexportRequest = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostCreateanewexportRequestData, ThrowOnError>
) =>
  (options.client ?? client).post<
    PostCreateanewexportRequestResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activities/exports',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get export details
 *
 * API to fetch details of the export activities.
 */
export const getExportdetails = <ThrowOnError extends boolean = false>(
  options: Options<GetExportdetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetExportdetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activities/exports/{exportId}',
    ...options,
  });

/**
 * List activities with filters
 *
 * This API is used to list activities with filters.The `filters` in the request body can be used to filter the list of activities by a start and end date, by list of users or usergroups who performed actions that created the activities, and by list of activity types.  <br> This API can also be used to list activities by specific objectId and objectType by using the query parameters. <br> This API uses cursor based pagination (see `lastId` and `pageSize` query params) and does not support range headers.
 */
export const postActivitiesList = <ThrowOnError extends boolean = false>(
  options: Options<PostActivitiesListData, ThrowOnError>
) =>
  (options.client ?? client).post<
    PostActivitiesListResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activities/list',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Activity Details by activityId
 *
 * API to fetch details an activity by id
 */
export const activityDetailsbyactivityId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ActivityDetailsbyactivityIdData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ActivityDetailsbyactivityIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activities/{activityId}',
    ...options,
  });

/**
 * Activity logs by activityId
 *
 * API to fetch list of logs of an activity by id
 */
export const activitylogsbyactivityId = <ThrowOnError extends boolean = false>(
  options: Options<ActivitylogsbyactivityIdData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ActivitylogsbyactivityIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activities/{activityId}/logs',
    ...options,
  });

/**
 * List all Clashes in a project
 *
 * List all Clashes in a project
 */
export const listallClashesinaproject = <ThrowOnError extends boolean = false>(
  options: Options<ListallClashesinaprojectData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListallClashesinaprojectResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/clashsets',
    ...options,
  });

/**
 * Create a New Clash
 *
 * You can create a new Clash Report using this action.
 */
export const createaNewClash = <ThrowOnError extends boolean = false>(
  options: Options<CreateaNewClashData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateaNewClashResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/clashsets',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete a Clash
 *
 * Delete a Clash
 */
export const deleteClash = <ThrowOnError extends boolean = false>(
  options: Options<DeleteClashData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteClashResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/clashsets/{clashId}',
    ...options,
  });

/**
 * Get Clash Details
 *
 * Get Clash Details
 */
export const getClashDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetClashDetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetClashDetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/clashsets/{clashId}',
    ...options,
  });

/**
 * Update Clash
 *
 * This API allows you to update the following properties of the Clash:
 *
 * - name
 *
 * - assignees
 */
export const updateClash = <ThrowOnError extends boolean = false>(
  options: Options<UpdateClashData, ThrowOnError>
) =>
  (options.client ?? client).patch<UpdateClashResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/clashsets/{clashId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    }
  );

/**
 * List All Clash Items
 *
 * This API returns a list of clash-items in the Clash.
 * **Note** : The center point will not be present for clash-items of legacy viewer based clashsets.
 */
export const listAllClashItems = <ThrowOnError extends boolean = false>(
  options: Options<ListAllClashItemsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListAllClashItemsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/clashsets/{clashId}/items',
    ...options,
  });

/**
 * List all Comments
 *
 * List all Comments
 */
export const listallComments = <ThrowOnError extends boolean = false>(
  options: Options<ListallCommentsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListallCommentsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/comments',
    ...options,
  });

/**
 * Create a New Comment
 *
 * You may create a new Comment using this action.
 */
export const createaNewComment = <ThrowOnError extends boolean = false>(
  options: Options<CreateaNewCommentData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateaNewCommentResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/comments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete a Comment
 *
 * Delete a Comment
 */
export const deleteComment = <ThrowOnError extends boolean = false>(
  options: Options<DeleteCommentData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteCommentResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/comments/{commentId}',
    ...options,
  });

/**
 * Get Comment Details
 *
 * Get Comment Details
 */
export const getCommentDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetCommentDetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetCommentDetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/comments/{commentId}',
    ...options,
  });

/**
 * Update Comment
 *
 * This API allows you to update description of the Comment:
 */
export const updateComment = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCommentData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateCommentResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/comments/{commentId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove attachments
 *
 * These set of APIs allow you to remove attachments to a Comment.
 *
 * This api takes request body as given below <br/>
 * [ <br/>
 * { <br/>
 * "id": "woC32em2Fb0",<br/>
 * "type": "FILE"<br/>
 * }<br/>
 * ]
 */
export const deleteRemoveattachments = <ThrowOnError extends boolean = false>(
  options: Options<DeleteRemoveattachmentsData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteRemoveattachmentsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/comments/{commentId}/attachments',
    ...options,
  });

/**
 * List all attachments
 *
 * These set of APIs allow you to list attachments to a Comment.
 */
export const getListallattachments = <ThrowOnError extends boolean = false>(
  options: Options<GetListallattachmentsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetListallattachmentsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/comments/{commentId}/attachments',
    ...options,
  });

/**
 * Add attachments
 *
 * These set of APIs allow you to add attachments to a Comment.
 */
export const postAddattachments = <ThrowOnError extends boolean = false>(
  options: Options<PostAddattachmentsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    PostAddattachmentsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/comments/{commentId}/attachments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List reactions to a comment
 *
 * List reactions to a comment. Cursor based pagination is used with optional `pageSize` query params. The default value of `pageSize` is 100.
 *
 * **Note:** The result items might not have the same count as in `pageSize`. The client must keep paginating until the `links.next` is empty in the response.
 */
export const listReactionsToComment = <ThrowOnError extends boolean = false>(
  options: Options<ListReactionsToCommentData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListReactionsToCommentResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/comments/{commentId}/reactions',
    ...options,
  });

/**
 * Adds user's reaction to a comment
 *
 * Add user's reaction to a comment. Multiple different reactons are allowed, but not duplicates of the same reaction for the same user.
 */
export const addReactionToComment = <ThrowOnError extends boolean = false>(
  options: Options<AddReactionToCommentData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AddReactionToCommentResponses,
    AddReactionToCommentErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/comments/{commentId}/reactions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete users reaction to a comment
 *
 * Removes user reaction to a comment. The deletion is hard, meaning the delete operation is undoable.
 */
export const deleteReactionToComment = <ThrowOnError extends boolean = false>(
  options: Options<DeleteReactionToCommentData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteReactionToCommentResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/comments/{commentId}/reactions/{reactionId}',
    ...options,
  });

/**
 * List Companies
 *
 * Company user can get the list of associated companies.
 *
 * @deprecated
 */
export const listCompanies = <ThrowOnError extends boolean = false>(
  options?: Options<ListCompaniesData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListCompaniesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/companies',
    ...options,
  });

/**
 * Get Company Details
 *
 * API for company user/admin to get details of a company.
 *
 * @deprecated
 */
export const getCompanyDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetCompanyDetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetCompanyDetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/companies/{companyId}',
    ...options,
  });

/**
 * Update Company
 *
 * The company admin can update the company name, website and domains of the company.
 *
 * @deprecated
 */
export const updateCompany = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCompanyData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateCompanyResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/companies/{companyId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove Company Email Domains
 *
 * API for company admin to remove email domains from company.
 *
 * @deprecated
 */
export const removeCompanyEmailDomains = <ThrowOnError extends boolean = false>(
  options: Options<RemoveCompanyEmailDomainsData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveCompanyEmailDomainsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/companies/{companyId}/domains',
    ...options,
  });

/**
 * Add Company Email Domains
 *
 * The company admin can update the company email domains. The entries will append to the existing domains.
 *
 * @deprecated
 */
export const addCompanyEmailDomains = <ThrowOnError extends boolean = false>(
  options: Options<AddCompanyEmailDomainsData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    AddCompanyEmailDomainsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/companies/{companyId}/domains',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Upload Company Image
 *
 * API for company admin to update the company logo by uploading an image file.
 *
 * @deprecated
 */
export const uploadCompanyImage = <ThrowOnError extends boolean = false>(
  options: Options<UploadCompanyImageData, ThrowOnError>
) =>
  (options.client ?? client).post<
    UploadCompanyImageResponses,
    unknown,
    ThrowOnError
  >({
    bodySerializer: null,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/companies/{companyId}/image',
    ...options,
    headers: {
      'Content-Type': 'text/plain',
      ...options.headers,
    },
  });

/**
 * Remove Users from Company
 *
 * API for company admin to remove users from the company.
 *
 * @deprecated
 */
export const removeUsersfromCompany = <ThrowOnError extends boolean = false>(
  options: Options<RemoveUsersfromCompanyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveUsersfromCompanyResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/companies/{companyId}/users',
    ...options,
  });

/**
 * List Users in a Company
 *
 * API for company user/admin to list users in the company.
 *
 * @deprecated
 */
export const listUsersinaCompany = <ThrowOnError extends boolean = false>(
  options: Options<ListUsersinaCompanyData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListUsersinaCompanyResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/companies/{companyId}/users',
    ...options,
  });

/**
 * Add Users to Company
 *
 * API for company admin to add users to the company.
 *
 * @deprecated
 */
export const addUserstoCompany = <ThrowOnError extends boolean = false>(
  options: Options<AddUserstoCompanyData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AddUserstoCompanyResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/companies/{companyId}/users',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove User from the Company
 *
 * API for company admin to remove the specified user from the company.
 *
 * @deprecated
 */
export const removeUserfromtheCompany = <ThrowOnError extends boolean = false>(
  options: Options<RemoveUserfromtheCompanyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveUserfromtheCompanyResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/companies/{companyId}/users/{userId}',
    ...options,
  });

/**
 * Update User in the Company
 *
 * API to change the role of the user in the company.
 *
 * @deprecated
 */
export const updateUserintheCompany = <ThrowOnError extends boolean = false>(
  options: Options<UpdateUserintheCompanyData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateUserintheCompanyResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/companies/{companyId}/users/{userId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Copy the File
 *
 * Creates a copy of an existing file.
 */
export const uploadFile = <ThrowOnError extends boolean = false>(
  options?: Options<UploadFileData, ThrowOnError>
) =>
  (options?.client ?? client).post<UploadFileResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/files',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Create a new export Request
 *
 * This API is used to create export Request for files in a project.
 */
export const createNewExportRequest = <ThrowOnError extends boolean = false>(
  options: Options<CreateNewExportRequestData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateNewExportRequestResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/files/export',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get export details
 *
 * API to fetch details of the export activities.
 */
export const getExportDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetExportDetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetExportDetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/files/export/{exportId}',
    ...options,
  });

/**
 * List Supported 2D, 3D & Spatial file formats
 *
 * API to list supported 2D, 3D & spatial file formats.
 */
export const listSupported2d3dSpatialfileformats = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListSupported2D3dSpatialfileformatsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListSupported2D3dSpatialfileformatsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/files/formats',
    ...options,
  });

/**
 * Commit File Upload
 *
 * After the content upload is completed, this API is called to complete the process and create file entity in TC.<br/><br/>The md5 of the file is required in the **digest** header for Multipart upload commits.
 *
 * @deprecated
 */
export const commitFileUpload = <ThrowOnError extends boolean = false>(
  options: Options<CommitFileUploadData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CommitFileUploadResponses,
    CommitFileUploadErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/files/fs/commit',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Initiate File upload
 *
 * **This API functionality is now supported by Package File Upload API**<br></br>These API support file uploads via presigned URL. 3 Steps include initiate upload, stream content and commit the upload process.Upload the content with the presigned url obtained from the Response of this API. Use PUT on the url from the Response to upload file content(no other parameters/headers required)<br/><br/> Multipart uploads require numberofparts and size as mandatory and it will result in list of upload URLs along with the part number. Each part in a multipart upload must be between 5 MiB (5,242,880 bytes) and 5 GiB (5,368,709,120 bytes). The last part can be smaller than 5 MiB (5,242,880 bytes). In general, part sizes should be as large as possible. Each part should be upload to corresponding part upload urls. <br/><br/> Multifile feature used to manage a collection of file objects as a single file resource is supported<br/> <br/>   The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version.<br/>  <br/>  If versionId provided in the **If-Match** header is not latest, error Response with Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &        **Error Message**: If-Match header value is not latest versionId.<br/> <br/>    If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 *
 * @deprecated
 */
export const initiateFileUpload = <ThrowOnError extends boolean = false>(
  options?: Options<InitiateFileUploadData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    InitiateFileUploadResponses,
    InitiateFileUploadErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/files/fs/initiate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Get the latest files and folders structure
 *
 * This API retrieves the latest state of files and folders in a project.
 */
export const getActiveFileFolderSnapshot = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetActiveFileFolderSnapshotData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetActiveFileFolderSnapshotResponses,
    GetActiveFileFolderSnapshotErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/files/fs/snapshot',
    ...options,
  });

/**
 * Get File Upload Details
 *
 * File upload details contains file name, parent information and uploadUrl. This api also provides the file upload status.
 */
export const getFileUploadDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetFileUploadDetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetFileUploadDetailsResponses,
    GetFileUploadDetailsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/files/fs/upload',
    ...options,
  });

/**
 * Package File upload
 *
 * This API is used to initiate the file upload. The file stream should be uploaded to the upload URL received in the response with the PUT operation and no additional headers including Authorization to be sent. You can use Get File Upload Details API to check the upload status after initiating the upload.</br> </br>This API can be used to upload files and their representation formats (like  thumbnail, TRB, PDF) as a single package. The API supports multipart and multifile uploads. Multipart upload requires the multipart flag to be passed as true in FileUploadContentDto and size of the file is mandatory to be passed for multipart upload. You should replace the * in the pre-signed url received in response with the part number while uploading the parts. If the file content size is greater than 5GB,it should be uploaded as multipart. Multipart file upload is supported only for source file. You should call the upload complete API after uploading all the parts.<br></br>Multi File/ fileset (upload a set of files in an archived format) is supported by passing the fileset and path template in FileUploadContentDto. Multipart upload is supported for filesets (multifiles).<br></br>Some combinations of file types in package upload may not be supported based on the model file format. Currently Source + TRB and Source + TRB + THUMB are not supported for drawing file formats (such as DWG / DXF).<br></br> Please make sure to upload the object only once to each uploadUrl (retries can be done in case of network related failures). If several successful uploads are executed to the the same uploadUrl, the random content from one of the uploads will be picked up for the permanent storage.</br></br> **Please note that the upload will be marked as EXPIRED if file content is not uploaded within 90 minutes for the single part upload and within 30 minutes for the mutlipart upload(after the complete API is called)**
 */
export const initiateFilePackageUpload = <ThrowOnError extends boolean = false>(
  options: Options<InitiateFilePackageUploadData, ThrowOnError>
) =>
  (options.client ?? client).post<
    InitiateFilePackageUploadResponses,
    InitiateFilePackageUploadErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/files/fs/upload',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Complete a multipart file upload
 *
 * Complete a multipart file upload when all parts of a multipart upload has been uploaded for a format
 */
export const completeMultipartFileUpload = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CompleteMultipartFileUploadData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CompleteMultipartFileUploadResponses,
    CompleteMultipartFileUploadErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/files/fs/upload/{uploadId}/complete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Representation File upload status
 *
 * Upload status of a file and committing representation upload
 *
 * @deprecated
 */
export const getFileUploadStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetFileUploadStatusData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetFileUploadStatusResponses,
    GetFileUploadStatusErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/files/fs/uploadstatus',
    ...options,
  });

/**
 * Download URL
 *
 * You can retrieve download URL for a single file using this action. (Part downloads supported with range headers). Use GET on the url from the Response to download file content (no other parameters/headers required)
 *
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are downloading on the latest version.
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 */
export const downloadUrl = <ThrowOnError extends boolean = false>(
  options: Options<DownloadUrlData, ThrowOnError>
) =>
  (options.client ?? client).get<DownloadUrlResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/files/fs/{fileId}/downloadurl',
    ...options,
  });

/**
 * Delete File
 *
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version. (applicable for single file upload, ignored for multiple file upload)
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 *
 * If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 */
export const deleteFile = <ThrowOnError extends boolean = false>(
  options: Options<DeleteFileData, ThrowOnError>
) =>
  (options.client ?? client).delete<DeleteFileResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/files/{fileId}',
      ...options,
    }
  );

/**
 * Get File Details
 *
 * This API will fetch the latest version details for the given file Id.
 *
 * To fetch a specific version information, optional query parameter __versionId__ can be specified.
 */
export const getFileDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetFileDetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetFileDetailsResponses,
    GetFileDetailsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { include: { array: { explode: false } } } },
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/files/{fileId}',
    ...options,
  });

/**
 * Update File Details
 *
 * You can rename the file using this API. To move the file, change the parentId to the id of the destination folder.
 *
 * In case both parentId and name is provided, move will take precedence before rename.
 *
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version.
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 *
 * If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 */
export const updateFileDetails = <ThrowOnError extends boolean = false>(
  options: Options<UpdateFileDetailsData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateFileDetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/files/{fileId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete alignment
 *
 * Remove alignment associated with a file.  If the **versionId** is presented for a given file version, only alignment associated with that version is removed, otherwise alignments for all version removed.
 */
export const deletealignment = <ThrowOnError extends boolean = false>(
  options: Options<DeletealignmentData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeletealignmentResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/files/{fileId}/alignment',
    ...options,
  });

/**
 * Get alignment
 *
 * Get the alignment for a given file. If the **versionId** is specified the alignment details for that particular version is retrieved else it will give the alignment details of the latest version.
 */
export const getalignment = <ThrowOnError extends boolean = false>(
  options: Options<GetalignmentData, ThrowOnError>
) =>
  (options.client ?? client).get<GetalignmentResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/files/{fileId}/alignment',
    ...options,
  });

/**
 * Create Alignment
 *
 * Create or update an alignment for a given file. It is assumed that the vectors axis and refDirection are orthonormal.
 *
 * Updates or creates alignment for the latest version of the file if versionId is not mentioned.
 */
export const createAlignment = <ThrowOnError extends boolean = false>(
  options: Options<CreateAlignmentData, ThrowOnError>
) =>
  (options.client ?? client).put<
    CreateAlignmentResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/files/{fileId}/alignment',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create alignment with matrix
 *
 * Create an alignment for a given file.  This api is deprecated.
 *
 * @deprecated
 */
export const createalignmentwithmatrix = <ThrowOnError extends boolean = false>(
  options: Options<CreatealignmentwithmatrixData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreatealignmentwithmatrixResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/files/{fileId}/alignment/matrix',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Checkin File
 *
 * You can checkin (release lock) on a file using this API, so its available for others to update
 */
export const checkinFile = <ThrowOnError extends boolean = false>(
  options: Options<CheckinFileData, ThrowOnError>
) =>
  (options.client ?? client).post<CheckinFileResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/files/{fileId}/checkin',
    ...options,
  });

/**
 * Checkout File
 *
 * You can checkout (lock) a file using this API
 */
export const checkoutFile = <ThrowOnError extends boolean = false>(
  options: Options<CheckoutFileData, ThrowOnError>
) =>
  (options.client ?? client).post<CheckoutFileResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/files/{fileId}/checkout',
      ...options,
    }
  );

/**
 * Get File Permissions
 *
 * This API gives the access control lists (ACLs) that specify the permissions for users and groups associated with a specific file.
 */
export const getFilePermissions = <ThrowOnError extends boolean = false>(
  options: Options<GetFilePermissionsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetFilePermissionsResponses,
    GetFilePermissionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/files/{fileId}/permissions',
    ...options,
  });

/**
 * Update File Permissions
 *
 * This API is used to add new permissions or update/remove existing permissions for a particular file given as input.<br>If any permissions exist for any users/group, they are removed (reset) and permissions provided in the request body are applied.<br>Input can be an ACL comprising lists of users and groups, with permissions set to either READ or FULL_ACCESS.<br>If the project level setting 'fullAccessIncludesPermissions' is enabled, project users with non admin rights will be able to share files.<br>Additionally, if the project level setting 'allowNonMemberPermissions' is enabled, files can be shared outside project context.<br>To represent the virtual 'All Members' group, use 'tc-groups:*' in the ACL.
 */
export const patchFilePermissions = <ThrowOnError extends boolean = false>(
  options: Options<PatchFilePermissionsData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    PatchFilePermissionsResponses,
    PatchFilePermissionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/files/{fileId}/permissions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get processing status of a File
 *
 * Returns the format processing status for 2D and 3D files. The valid return values are integer from 0 to 100, negative values indicate processing error.
 *
 * Supported formats are ifc, ifczip, 3dm, obj, skp, fbx, rvt, dwg, dxf, dgn, 3ds, stp, step, iges, igs, stl, doc, docx, xls, xlsx, rtf, txt, ppt, pptx, pdf, jpg, jpeg, gif, png, bmp, jpg, jpeg, gif, png, tif and tiff.
 */
export const getprocessingstatusofaFile = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetprocessingstatusofaFileData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetprocessingstatusofaFileResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/files/{fileId}/status',
    ...options,
  });

/**
 * Get versions of a File
 *
 * Get versions of a File
 */
export const getversionsofaFile = <ThrowOnError extends boolean = false>(
  options: Options<GetversionsofaFileData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetversionsofaFileResponses,
    unknown,
    ThrowOnError
  >({
    querySerializer: { parameters: { include: { array: { explode: false } } } },
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/files/{fileId}/versions',
    ...options,
  });

/**
 * Create a New Folder
 *
 * You can create a new Folder using this action. It takes a JSON object containing a parent Identifier and a name, both required.
 *
 * + name (string) - The name of the folder
 *
 * + parentId (string) - parent folder's version Id
 *
 * + tags (optional) - List of Tags to be linked with folder
 */
export const createaNewFolder = <ThrowOnError extends boolean = false>(
  options: Options<CreateaNewFolderData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateaNewFolderResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/folders',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Items in a Folder by path
 *
 * API returns the list of Folders and Files in the given path in the query parameter
 */
export const listItemsinaFolderbypath = <ThrowOnError extends boolean = false>(
  options: Options<ListItemsinaFolderbypathData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListItemsinaFolderbypathResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/folders/by_path',
    ...options,
  });

/**
 * Get Folder Permissions
 *
 * This API gives the access control lists (ACLs) that specify the permissions for users and groups associated with a specific folder.<br>Use the query parameter <code>fields</code> with value <code>inherited</code> to include inherited permissions in addition to direct permissions.
 */
export const getFolderPermissions = <ThrowOnError extends boolean = false>(
  options: Options<GetFolderPermissionsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetFolderPermissionsResponses,
    GetFolderPermissionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/folders/fs/{folderId}/permissions',
    ...options,
  });

/**
 * Update Folder Permissions
 *
 * This API is used to add new permissions or update/remove existing permissions for a particular folder given as input.<br>If any permissions exist for any users/group, they are removed (reset) and permissions provided in the request body are applied.<br>Input can be either defaultAccess (deprecated) or an ACL comprising lists of users and groups, with permissions set to either READ or FULL_ACCESS or NO_ACCESS.<br>If the project level setting 'fullAccessIncludesPermissions' is enabled, project users with non admin rights will be able to share folders.<br>Additionally, if the project level setting 'allowNonMemberPermissions' is enabled, folders can be shared outside project context.<br>To represent the virtual 'All Members' group, use 'tc-groups:*' in the ACL.
 */
export const patchFolderPermissions = <ThrowOnError extends boolean = false>(
  options: Options<PatchFolderPermissionsData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    PatchFolderPermissionsResponses,
    PatchFolderPermissionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/folders/fs/{folderId}/permissions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Folder Deletion Job Status
 *
 * Gets the status of a folder deletion job.
 */
export const getFolderDeletionJobStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFolderDeletionJobStatusData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetFolderDeletionJobStatusResponses,
    GetFolderDeletionJobStatusErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/folders/jobs/{jobId}',
    ...options,
  });

/**
 * Delete Folder
 *
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version. (applicable for single file upload, ignored for multiple file upload)
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 *
 * If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 */
export const deleteFolder = <ThrowOnError extends boolean = false>(
  options: Options<DeleteFolderData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteFolderResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/folders/{folderId}',
    ...options,
  });

/**
 * Get Folder Details
 *
 * Get Folder Details
 */
export const getFolderDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetFolderDetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetFolderDetailsResponses,
    GetFolderDetailsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/folders/{folderId}',
    ...options,
  });

/**
 * Update Folder
 *
 * You can use this API to move/rename the Folder.
 *
 * To move a folder, update the parentId attribute.
 * In case both parentId and name is provided, move will take precedence before rename.
 *
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version. (applicable for single file upload, ignored for multiple file upload)
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 *
 * If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 * You can use this API to move/rename the Folder.<br/> <br/> To move a folder, update the parentId attribute.<br/> <br/> In case both parentId and name is provided, move will take precedence before rename. <br/> <br/> The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version. (applicable for single file upload, ignored for multiple file upload) <br/> <br/> If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &  **Error Message**: If-Match header value is not latest versionId. <br/> <br/> If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 */
export const updateFolder = <ThrowOnError extends boolean = false>(
  options: Options<UpdateFolderData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateFolderResponses,
    UpdateFolderErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/folders/{folderId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Folder
 *
 * Deletes the folder with the given folder ID.<br><br>- <b>Empty Folder:</b><br>  If the folder is empty, it will be deleted . The API responds with <code>204 No Content</code>.<br>- <b>Non-Empty Folder (force not set or false):</b><br>  If the folder contains items and the optional `force` query parameter is not provided or set to `false`, the deletion is rejected with an error indicating that `force=true` is required to delete non-empty folders.<br>- <b>Non-Empty Folder (force=true):</b><br>  If the folder contains items and `force` is set to `true`, the deletion is processed asynchronously. The API responds with <code>202 Accepted</code> and includes a `Location` header containing the URI to check the deletion job status. Clients can use this URI or the returned job ID to poll for completion status.
 */
export const deleteFolder2 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteFolder2Data, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteFolder2Responses,
    DeleteFolder2Errors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/folders/{folderId}/delete',
    ...options,
  });

/**
 * Get File/Folder Details By parent folder id and name
 *
 * Fetches the file/folder details as per the given parent folder id and name that user has access to. If no details present, **NOT_FOUND** exception will be thrown.
 */
export const getFileFolderDetailsByName = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFileFolderDetailsByNameData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetFileFolderDetailsByNameResponses,
    GetFileFolderDetailsByNameErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/folders/{folderId}/item',
    ...options,
  });

/**
 * List Items in a Folder
 *
 * List Items in a Folder
 */
export const listItemsinaFolderV21 = <ThrowOnError extends boolean = false>(
  options: Options<ListItemsinaFolderV21Data, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListItemsinaFolderV21Responses,
    unknown,
    ThrowOnError
  >({
    querySerializer: { parameters: { include: { array: { explode: false } } } },
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/folders/{folderId}/items',
    ...options,
  });

/**
 * Remove any existing Folder Permission
 *
 * This API allows to removes specified given permission to given user/group and recomputes permission for actor based on user roles and default permission.
 * It takes optional cascade field to delete permissions on subfolders recursively.
 * You can specify the versionId in the If-Match header to validate you are working off the latest version of the folder.
 *
 * This API takes propagation flag and a list of Permissions as a Request Body, each permission has following fields
 *
 * - id (id of User or Group)
 *
 * - type
 *
 * Example : <br/>
 * {<br/>
 * "cascade": "true",<br/>
 * "permissions": [<br/>
 * {<br/>
 * "id": "0Z-OMo67VtY",<br/>
 * "type": "USER"<br/>
 * },<br/>
 * {<br/>
 * "id": "swO2L9AqeT0",<br/>
 * "type": "GROUP"<br/>
 * }<br/>
 * ]<br/>
 * }<br/>
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version. (applicable for single file upload, ignored for multiple file upload)
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 *
 * If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 *
 * @deprecated
 */
export const removeanyexistingFolderPermission = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RemoveanyexistingFolderPermissionData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveanyexistingFolderPermissionResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/folders/{folderId}/permissions',
    ...options,
  });

/**
 * Get Folder Permissions
 *
 * This API gives a list of Permissions that are applied to a given folder
 *
 * @deprecated
 */
export const getFolderPermissions2 = <ThrowOnError extends boolean = false>(
  options: Options<GetFolderPermissions2Data, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetFolderPermissions2Responses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/folders/{folderId}/permissions',
    ...options,
  });

/**
 * Update existing Folder Permission
 *
 * This API allows to update existing folder Permissions or add permissions for new users/groups. It can also be used to reset the default permission.
 * It takes optional cascade field to update permissions on subfolders recursively.
 * You can specify the versionId in the If-Match header to validate you are working off the latest version of the folder.
 * This API takes default permission, propagation flag and a list of Permissions.
 * Each permission has following fields:
 *
 * - id (id of User or Group)
 *
 * - type
 *
 * - permission
 *
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version. (applicable for single file upload, ignored for multiple file upload)
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 *
 * If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 * Inheritance flag will be set to false by default.
 *
 * @deprecated
 */
export const updateexistingFolderPermission = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateexistingFolderPermissionData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateexistingFolderPermissionResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/folders/{folderId}/permissions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Add a New Folder Permission
 *
 * This API allows to create a new folder Permission for users/groups. If any permissions exist for any users/group, they are removed (reset) and permissions provided in Request body are applied.
 * It can also be used to reset the default permission.
 * It takes optional cascade field to add permissions on subfolders recursively.
 * You can specify the versionId in the If-Match header to validate you are working off the latest version of the folder.
 *
 * This API takes a default permission, propagation flag and a list of Permissions.
 * Each permission has following fields:
 *
 * - id (id of User or Group)
 *
 * - type
 *
 * - permission
 *
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version. (applicable for single file upload, ignored for multiple file upload)
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 *
 * If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 * Inheritance flag will be set to false by default.
 *
 * @deprecated
 */
export const addaNewFolderPermission = <ThrowOnError extends boolean = false>(
  options: Options<AddaNewFolderPermissionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AddaNewFolderPermissionResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/folders/{folderId}/permissions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get versions of a Folder
 *
 * Get versions of a Folder
 */
export const getversionsofaFolder = <ThrowOnError extends boolean = false>(
  options: Options<GetversionsofaFolderData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetversionsofaFolderResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/folders/{folderId}/versions',
    ...options,
  });

/**
 * List Groups in a project
 *
 * List Groups in a project
 */
export const listGroupsinaproject = <ThrowOnError extends boolean = false>(
  options: Options<ListGroupsinaprojectData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListGroupsinaprojectResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/groups',
    ...options,
  });

/**
 * Create a New Group
 *
 * You can create a new group using this action. You need to provide a project id in which the group should be created and group name
 */
export const createaNewGroup = <ThrowOnError extends boolean = false>(
  options: Options<CreateaNewGroupData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateaNewGroupResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/groups',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Group
 *
 * You can use this API to delete a Group.
 */
export const deleteGroup = <ThrowOnError extends boolean = false>(
  options: Options<DeleteGroupData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteGroupResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/groups/{groupId}',
    ...options,
  });

/**
 * Get Group Details
 *
 * Get the details of a group.
 */
export const getGroupDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetGroupDetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetGroupDetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/groups/{groupId}',
    ...options,
  });

/**
 * Rename Group
 *
 * You can use this API to rename the Group.
 */
export const renameGroup = <ThrowOnError extends boolean = false>(
  options: Options<RenameGroupData, ThrowOnError>
) =>
  (options.client ?? client).patch<RenameGroupResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/groups/{groupId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    }
  );

/**
 * Delete users from group
 *
 * Use this API to remove users from an existing group <br/>
 * [<br/>
 * {<br/>
 * "id": "Dyfw481f299"<br/>
 * },<br/>
 * {<br/>
 * "id": "T2P8S-tqF7s"<br/>
 * }<br/>
 * ]
 */
export const deleteusersfromgroup = <ThrowOnError extends boolean = false>(
  options: Options<DeleteusersfromgroupData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteusersfromgroupResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/groups/{groupId}/users',
    ...options,
  });

/**
 * List Users in a Group
 *
 * API returns the list of Users in the given groupId. Only Active and Pending users will be displayed. Removed users will not be listed.
 */
export const listUsersinaGroup = <ThrowOnError extends boolean = false>(
  options: Options<ListUsersinaGroupData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListUsersinaGroupResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/groups/{groupId}/users',
    ...options,
  });

/**
 * Add users to group
 *
 * Use this API to add users to an existing group
 */
export const adduserstogroup = <ThrowOnError extends boolean = false>(
  options: Options<AdduserstogroupData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AdduserstogroupResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/groups/{groupId}/users',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List linked entities for objects
 *
 * This API returns the list of links based on the version Id of the 3d model and the object Id (or object source Id). Either id or versionId parameter must be provided.
 */
export const listlinkedentitiesforobjects = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListlinkedentitiesforobjectsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListlinkedentitiesforobjectsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/objectlink',
    ...options,
  });

/**
 * Create object link
 *
 * This API creates a single object link. New Target TOPIC is added which accepts Topic uuid as Id
 */
export const createobjectlink = <ThrowOnError extends boolean = false>(
  options: Options<CreateobjectlinkData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateobjectlinkResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/objectlink',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Bulk create object links
 *
 * This api bulk creates a collection of object links. New Target TOPIC is added which accepts Topic uuid as Id
 */
export const bulkcreateobjectlinks = <ThrowOnError extends boolean = false>(
  options: Options<BulkcreateobjectlinksData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkcreateobjectlinksResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/objectlink/objectlinks',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List links for the given target entity
 *
 * This API returns the set of object links for a given target. For versioned target, either id or versionId must be provided. For ISSUE target, contextId is required.
 */
export const listlinksforthegiventargetentity = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListlinksforthegiventargetentityData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListlinksforthegiventargetentityResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/objectlink/target',
    ...options,
  });

/**
 * Delete an object link
 *
 * Delete an object link
 */
export const deleteaobjectlink = <ThrowOnError extends boolean = false>(
  options: Options<DeleteaobjectlinkData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteaobjectlinkResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/objectlink/{linkId}',
    ...options,
  });

/**
 * Update object links
 *
 * Update object links
 */
export const updateobjectlinks = <ThrowOnError extends boolean = false>(
  options: Options<UpdateobjectlinksData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateobjectlinksResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/objectlink/{linkId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List all Projects
 *
 * API to list all the projects for the user. Folders count metric includes the root folder as well.
 */
export const listallProjects = <ThrowOnError extends boolean = false>(
  options?: Options<ListallProjectsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListallProjectsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects',
    ...options,
  });

/**
 * Create a New Project
 *
 * You may create a new Project using this action.
 *
 * TC supports max length of 255 characters for project names. Names are validated according to OS supported rules, so ones that contain non-printable ascii or with special meaning will be rejected by the API (Ex: "..", "PRN", "/")
 */
export const createaNewProject = <ThrowOnError extends boolean = false>(
  options: Options<CreateaNewProjectData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateaNewProjectResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Request access to projects the user is not part of.
 *
 * This API allows users to request access to project they are not currently part of by triggering an email to project admins.
 */
export const requestProjectAccess = <ThrowOnError extends boolean = false>(
  options: Options<RequestProjectAccessData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RequestProjectAccessResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/accessRequests',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Clone project from existing project
 *
 * This API facilitates the creation of a new project by cloning an existing one.
 * API supports cloning settings, users, groups, folders and permissions of an
 * existing project. It generates a request to clone the given project and returns
 * the details of the clone process. Status of the clone process can be tracked
 * using the GET project clone details API.
 *
 *
 * The 'include' field in the request body indicate the items to be included in
 * clone. The selection of these items could be done in any manner. Only those
 * items that are selected will be included in clone.
 *
 *
 * However, there is also a special scenario
 *
 *
 * `*` => implicitly includes all options (folders, users, groups, settings and folderPermissions)
 *
 *
 * Examples on how different values in 'include' control the clone behavior
 *
 *
 * - folders + users => folders and users alone will be cloned
 *
 * - folders + groups => folders and groups alone will be cloned
 *
 * - folders + users + settings => folders, users and settings alone will be cloned
 *
 * - folders + folderPermissions => folders and default folder permissions will be cloned
 *
 * - folders + users + folderPermissions => folders, users, default folder permissions and user permissions in folder level will be cloned
 *
 * - folders + groups + folderPermissions => folders, groups, default default permissions and group permissions in folder level will be cloned.
 *
 * - folders + folderPermissions + settings => folders, folder default permissions and settings will be cloned
 *
 * - `*` => all items (folders, users, groups, respective folder permissions and settings) will be cloned
 *
 * - settings + users + groups + folderPermissions =>   settings, users and groups will be cloned
 *
 * `Permission level required:` Only project admins can perform the project clone operation
 */
export const cloneProject = <ThrowOnError extends boolean = false>(
  options: Options<CloneProjectData, ThrowOnError>
) =>
  (options.client ?? client).post<CloneProjectResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/projects/clones',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    }
  );

/**
 * Get the details of project clone
 *
 * API to fetch details of the project clone. The response will contain the id of the cloned project (inside the `result` object) in case of successful clone, or will contain information about the reason for failure in case of clone failure.
 *
 * `Permission level required:` This API can be accessed only by the user who initiated the project clone
 */
export const getProjectCloneDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectCloneDetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProjectCloneDetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/clones/{cloneId}',
    ...options,
  });

/**
 * List all projects with minimal information
 *
 * This API is used to fetch the project details of logged-in user which contains following details:projectId, role of logged-in user in the project and the list of group identifiers. Can be used as an efficient way to fetch a list of projects user is member of for making e.g. autorization decision.
 */
export const listAllProjectsMini = <ThrowOnError extends boolean = false>(
  options?: Options<ListAllProjectsMiniData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListAllProjectsMiniResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/me',
    ...options,
  });

/**
 * Delete Project
 *
 * API to delete a project
 */
export const deleteProject = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProjectData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteProjectResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}',
    ...options,
  });

/**
 * Get Project Details
 *
 * API to fetch details of a project.Folders count metric includes the root folder as well.
 *
 * Note : An empty object for "license" property indicates that the project does not have any license mapped with it in ECom Enforcement rules.
 */
export const getProjectDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectDetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProjectDetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}',
    ...options,
  });

/**
 * Update Project
 *
 * The following properties can be updated using this request (any field can be updated individually)
 * * name
 * * address
 * * description
 * * startDate
 * * endDate
 * * lastVisitedOn
 * * crs
 *
 * *The date can be reset to NULL if you pass empty string as input for startDate and endDate*
 *
 * **Note :** For startDate and endDate, only the date will be considered from the timestamp, not the time or timezone.
 */
export const updateProject = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProjectData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateProjectResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Upload Project Image
 *
 * API to set an image for the project <br> Supported types are **jpg,jpeg,gif,png,tif,tiff,bmp**
 */
export const uploadProjectImage = <ThrowOnError extends boolean = false>(
  options: Options<UploadProjectImageData, ThrowOnError>
) =>
  (options.client ?? client).post<
    UploadProjectImageResponses,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/image',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Get Project license details
 *
 * API to get license details for a project.
 */
export const getProjectlicensedetails = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectlicensedetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProjectlicensedetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/license',
    ...options,
  });

/**
 * Update Project license
 *
 * API to update the license assigned to a project by license id. This API is accessible for all the project admins to update the project's license using one of their active licenses. Additionally, site admins can utilize this API to update a project's license on behalf of a user, using any active license assigned to that user by passing subscriptionId in the request body.
 */
export const updateProjectLicenseDetails = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateProjectLicenseDetailsData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateProjectLicenseDetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/license',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Project Metrics
 *
 * API to fetch metrics of a project. Folders count metric includes the root folder as well.
 */
export const getProjectMetrics = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectMetricsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProjectMetricsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/metrics',
    ...options,
  });

/**
 * Get project content changes since last time
 *
 * Fetch the changes in the project content happend after the sync cursor value proved in the `status` parameter.
 * The API allows to fetch changes in project files and folders. Each change represents a new version of the file or folder. Changes are ordered by the time. The API can be thought of as a stream of change events, client fetches events from the stream using a cursor (skipToken) that represents a position in the stream. If skipToken is not provided then events are fetched from the beginning of the project history, otherwise only events that happen after the given cursor are returned. The API allows to implement efficient incremental synchronisation (or cache invalidation) for the project file system on the client side.
 */
export const getProjectSyncObjects = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectSyncObjectsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProjectSyncObjectsResponses,
    GetProjectSyncObjectsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/objects',
    ...options,
  });

/**
 * List roles available in project
 *
 * API to list the roles available in a project.
 */
export const listrolesavailableinproject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListrolesavailableinprojectData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListrolesavailableinprojectResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/roles',
    ...options,
  });

/**
 * Get Project settings
 *
 * API to List all the project specific settings.
 */
export const getProjectsettings = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectsettingsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProjectsettingsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/settings',
    ...options,
  });

/**
 * Update Project Settings
 *
 * This API will set all settings related to project. Generally sets sync,notifications,unit settings. "ALLOW_AUTO_CHECKOUT" is the default value in case if sync mode is not given in sync settings.
 *
 * **Unit Settings :**
 * API allows to reset all the values to metric/imperial/USSurveyFeet if unitsystem is the only attribute in the api Request. Custom unit system allows setting mix and match values.
 *
 * eg: "unitSettings": {
 * "unitsystem": "metric”
 * }
 *
 * **Acceptable values for unitsettings :**
 *
 * <p>Decimal precisions - (0, 0.1, 0.01, 0.001, 0.0001, 0.00001, 0.000001, 0.0000001, 0.00000001)<br>
 * Fractional precisions -(1/2,1/4,1/8,1/16,1/32,1/64)<br></p>
 *
 * unitsystem - (metric, imperial, USSurveyFeet, custom)
 * <p align="right"><i>Defaults are in bold</i></p>
 * <table>
 * <tr>
 * <td></td>
 * <th>metric</th>
 * <th>imperial</th>
 * <th>USSurveyFeet</th>
 * </tr>
 * <tr>
 * <td>lengthunit</td>
 * <td><b>mm</b> - <b>0</b>
 * <br/>cm - <b>0.1</b>
 * <br/>m - <b>0.01</b>
 * <br/>km  - <b>0.001</b></td>
 * <td><b>in</b> - <b>0.1</b>
 * <br/>ft-in - <b>1/4</b>
 * <br/>ft - <b>0.01</b>
 * <br/>yd - <b>0.01</b>
 * <br/>mi - <b>0.001</b>
 * <br/>usft - <b>0.001</b></td>
 * <td>sIN - <b>0.1</b>
 * <br/><b>sFT</b> - <b>0.01</b>
 * <br/>sYD - <b>0.01</b>
 * <br/>sMI - <b>0.001</b></td>
 * </tr>
 * <tr>
 * <td>lengthmeasurementunit</td>
 * <td><b>mm</b> - <b>0</b>
 * <br/>cm - <b>0.1</b>
 * <br/>m - <b>0.01</b>
 * <br/>km - <b>0.001</b></td>
 * <td><b>in</b> - <b>0.1</b>
 * <br/>ft-in - <b>1/4</b>
 * <br/>ft - <b>0.01</b>
 * <br/>yd - <b>0.01</b>
 * <br/>mi - <b>0.001</b></td>
 * <td>sIN - <b>0.1</b>
 * <br/><b>sFT</b> - <b>0.01</b>
 * <br/>sYD - <b>0.01</b>
 * <br/>sMI - <b>0.001</b></td>
 * </tr>
 * <tr>
 * <td>areaunit</td>
 * <td>mm2 - <b>0</b>
 * <br/>cm2 - <b>0.1</b>
 * <br/><b>m2</b> - <b>0.01</b>
 * <br/>ha - <b>0.001</b></td>
 * <td>in2 - <b>0.1</b>
 * <br/><b>ft2</b> - <b>0.01</b>
 * <br/>yd2 - <b>0.001</b>
 * <br/>ac - <b>0.001</b>
 * <br/>mi2 - <b>0.001</b>
 * <br/>usft2 - <b>0.001</b>
 * <br/>usyd2 - <b>0.001</b></td>
 * <td>in2 - <b>0.1</b>
 * <br/><b>ft2</b> - <b>0.01</b>
 * <br/>yd2 - <b>0.001</b></td>
 * </tr>
 * <tr>
 * <td>volumeunit</td>
 * <td>mm3 - <b>0</b>
 * <br/>cm3 - <b>0.1</b>
 * <br/><b>m3</b> - <b>0.01</b></td>
 * <td>in3 - <b>0.1</b>
 * <br/>ft3 - <b>0.01</b>
 * <br/><b>yd3</b> - <b>0.001</b>
 * <br/>usft3 - <b>0.001</b>
 * <br/>usyd3 - <b>0.001</b>
 * <br/>acft - <b>0.001</b>
 * <br/>usacft - <b>0.001</b></td>
 * <td>in3 - <b>0.1</b>
 * <br/>ft3 - <b>0.01</b>
 * <br/><b>yd3</b> - <b>0.001</b></td>
 * </tr>
 * <tr>
 * <td>weightunit</td>
 * <td>mg - <b>0</b>
 * <br/>g - <b>0.1</b>
 * <br/>kg - <b>0.01</b>
 * <br/><b>t</b> - <b>0.001</b></td>
 * <td>oz - <b>0.1</b>
 * <br/>lb - <b>0.01</b>
 * <br/><b>ton</b> - <b>0.001</b>
 * <br/>stone - <b>0.001</b></td>
 * <td>oz - <b>0.1</b>
 * <br/>lb - <b>0.01</b>
 * <br/><b>ton</b> - <b>0.001</b></td>
 * </tr>
 * <tr>
 * <td>angularunit</td>
 * <td><b>deg</b> - <b>0.001</b>
 * <br/>rad - <b>0.01</b>
 * <br/>deg-min-sec - <b>0.001</b></td>
 * <td><b>deg</b> - <b>0.001</b>
 * <br/>rad - <b>0.01</b>
 * <br/>deg-min-sec - <b>0.001</b></td>
 * <td><b>deg</b> - <b>0.001</b>
 * <br/>rad - <b>0.01</b>
 * <br/>deg-min-sec - <b>0.001</b></td>
 * </tr>
 * </table>
 */
export const updateProjectSettings = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProjectSettingsData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateProjectSettingsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/settings',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get project content sync cursor.
 *
 * Returns the project content sync cursor. This sync cursor is exected to be used together with the `ObjectSync` API to detect changes in the project content and do the incremental sync.
 */
export const getProjectSyncStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectSyncStatusData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProjectSyncStatusResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/status',
    ...options,
  });

/**
 * List all Users in project
 *
 * API to fetch list of users in a project
 */
export const listallUsersinproject = <ThrowOnError extends boolean = false>(
  options: Options<ListallUsersinprojectData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListallUsersinprojectResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/users',
    ...options,
  });

/**
 * Add/Invite Users to project
 *
 *  This API allows you to invite new and existing users to a project.
 *
 * Email address and role are required to add users to project.
 *
 * The Response will be minimal for user not in Trimble Connect and for the users in the Trimble Connect there will be complete Response.
 *
 * In mininal Response there will be only three fields in the Response body **Email** , **status** , **role**
 */
export const addInviteUserstoproject = <ThrowOnError extends boolean = false>(
  options: Options<AddInviteUserstoprojectData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AddInviteUserstoprojectResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/users',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove user
 *
 * API to remove a particular user from the project
 */
export const removeuser = <ThrowOnError extends boolean = false>(
  options: Options<RemoveuserData, ThrowOnError>
) =>
  (options.client ?? client).delete<RemoveuserResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/projects/{projectId}/users/{userId}',
      ...options,
    }
  );

/**
 * Get User Details
 *
 * API to get user details by project Id and  Trimble Connect user identifier(userId). Use `me` alias (`/projects/{projectId}/users/me`) to get details about the user associated with the passed access token.
 */
export const getProjectUserDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectUserDetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProjectUserDetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/users/{userId}',
    ...options,
  });

/**
 * Update User role
 *
 * API to update the role of user in a project
 */
export const updateUserrole = <ThrowOnError extends boolean = false>(
  options: Options<UpdateUserroleData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateUserroleResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/users/{userId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Available Regions
 *
 * Get Available Regions
 */
export const getAvailableRegions = <ThrowOnError extends boolean = false>(
  options?: Options<GetAvailableRegionsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetAvailableRegionsResponses,
    unknown,
    ThrowOnError
  >({ url: '/regions', ...options });

/**
 * List all Releases
 *
 * This API will fetch all the releases for the project. To fetch specific release status the optional __status__ query parameter can be used.
 */
export const listallReleases = <ThrowOnError extends boolean = false>(
  options: Options<ListallReleasesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListallReleasesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/releases',
    ...options,
  });

/**
 * Create a New Release
 *
 * API to create a new Release.
 *
 * + name (string) - Name of the release
 *
 * + dueDate (timestamp) - Due date for the release
 *
 * + projectId (string) - Project Identifier
 *
 * Following fields can be optionally specified while creating the release:
 *
 * + notes (string) - notes for the release
 *
 * + recipients (array of users/groups) - recipients of the release
 */
export const createaNewRelease = <ThrowOnError extends boolean = false>(
  options: Options<CreateaNewReleaseData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateaNewReleaseResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/releases',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Download files in release
 *
 * You can download the file versions associated to a release. List of versionIds should be passed in the Request. If multiple file versions passed in the Request body, the output will be zip file format. If no versions passed in the Request body (i.e empty array),  all file versions associated to the release will be downloaded
 */
export const downloadfilesinrelease = <ThrowOnError extends boolean = false>(
  options: Options<DownloadfilesinreleaseData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DownloadfilesinreleaseResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/releases/downloadFiles',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Release
 *
 * API to delete a release
 */
export const deleteRelease = <ThrowOnError extends boolean = false>(
  options: Options<DeleteReleaseData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteReleaseResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/releases/{releaseId}',
    ...options,
  });

/**
 * Get Release Details
 *
 * Get Release Details
 */
export const getReleaseDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetReleaseDetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetReleaseDetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/releases/{releaseId}',
    ...options,
  });

/**
 * Edit Release
 *
 * This API allows you to update the following properties of the Release:
 *
 * - name
 *
 * - dueDate
 *
 * - notes
 *
 * - recipients
 *
 * - status
 *
 * To send the release to recipients, the __status__ property has to be set as "SENT" in the Request body.
 */
export const editRelease = <ThrowOnError extends boolean = false>(
  options: Options<EditReleaseData, ThrowOnError>
) =>
  (options.client ?? client).patch<EditReleaseResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/releases/{releaseId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    }
  );

/**
 * Remove files
 *
 * You can remove files from release using this API. This api takes below json as request body <br/>
 * [<br/>
 * {<br/>
 * "id": "woC32em2Fb0",<br/>
 * "type": "FILE"<br/>
 * }<br/>
 * ]<br/>
 */
export const removefiles = <ThrowOnError extends boolean = false>(
  options: Options<RemovefilesData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemovefilesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/releases/{releaseId}/files',
    ...options,
  });

/**
 * List all files
 *
 * This API returns a list of files for the Release
 */
export const listallfiles = <ThrowOnError extends boolean = false>(
  options: Options<ListallfilesData, ThrowOnError>
) =>
  (options.client ?? client).get<ListallfilesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/releases/{releaseId}/files',
    ...options,
  });

/**
 * Add files
 *
 * You can add files using this API to Release.
 */
export const addfiles = <ThrowOnError extends boolean = false>(
  options: Options<AddfilesData, ThrowOnError>
) =>
  (options.client ?? client).post<AddfilesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/releases/{releaseId}/files',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List All Search Results
 *
 * List All Search Results
 */
export const listAllSearchResults = <ThrowOnError extends boolean = false>(
  options: Options<ListAllSearchResultsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListAllSearchResultsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/search',
    ...options,
  });

/**
 * List all Shares
 *
 * This API will fetch all the shares by the user.
 *
 * If the calling user is the project admin, then the Response will have all shares for the  given projectId, else it will return the shares created by that user in project.
 *
 * If the projectId is not given, then the API Response will have shares across all the projects for the calling user.
 *
 * The default limit will be 25 elemenets, maximum of 1000 elements can be fetched on ranged Request
 */
export const listallShares = <ThrowOnError extends boolean = false>(
  options?: Options<ListallSharesData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListallSharesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/shares',
    ...options,
  });

/**
 * Create a New Share
 *
 * You may create a new Share using this action.
 *
 * Depending on mode, for "PROJECT_USERS", valid values for "notify" object's "type" field are ['USER', 'GROUP'], and for other two modes, valid type is "EMAIL" (with "id" being the actual email address)
 *
 * For Objects array, in case of FILE object type, user can specify optional "useLatestVersion" boolean field. Defaults to "true".
 *
 * For "PROJECT_USERS" mode, "expiryDate", "permission", and "useLatestVersion" are defaulted and cannot be specified in the API.
 *
 * - expiryDate : never
 *
 * - permission : DOWNLOAD
 *
 * - useLatestVersion : TRUE
 */
export const createaNewShare = <ThrowOnError extends boolean = false>(
  options: Options<CreateaNewShareData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateaNewShareResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/shares',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Share Details along with public accesstoken.
 *
 * Get details of the particular share using share token along with accessToken to access the files shared in public mode
 */
export const getShareDetailsWithAccessTokenUsingStoken = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetShareDetailsWithAccessTokenUsingStokenData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetShareDetailsWithAccessTokenUsingStokenResponses,
    unknown,
    ThrowOnError
  >({ url: '/shares/token/{stoken}', ...options });

/**
 * Delete Share
 *
 * This API will allow you to revoke the share. Shared URLs will be invalidated.
 */
export const deleteShare = <ThrowOnError extends boolean = false>(
  options: Options<DeleteShareData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteShareResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/shares/{shareId}',
    ...options,
  });

/**
 * Get Share Details
 *
 * Get Share Details
 */
export const getShareDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetShareDetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetShareDetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/shares/{shareId}',
    ...options,
  });

/**
 * Edit Share
 *
 * This API allows you to update the properties of the Share.
 *
 * Depending on mode, for "PROJECT_USERS", valid values for "notify" object's "type" field are ['USER', 'GROUP'], and for other two modes, valid type is "EMAIL" (with "id" being the actual email address)
 *
 * For "PROJECT_USERS" mode, "expiryDate", "permission", and "useLatestVersion" are defaulted and cannot be specified in the API. The defaults are:
 *
 * - expiryDate : never
 * - permission : DOWNLOAD
 * - useLatestVersion : true
 */
export const editShare = <ThrowOnError extends boolean = false>(
  options: Options<EditShareData, ThrowOnError>
) =>
  (options.client ?? client).patch<EditShareResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/shares/{shareId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Tags in a project
 *
 * API to list Tags under a project / mapped with an object
 */
export const listTagsinaproject = <ThrowOnError extends boolean = false>(
  options?: Options<ListTagsinaprojectData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListTagsinaprojectResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tags',
    ...options,
  });

/**
 * Create Tag
 *
 * API to create a Tag under a project
 */
export const createTag = <ThrowOnError extends boolean = false>(
  options: Options<CreateTagData, ThrowOnError>
) =>
  (options.client ?? client).post<CreateTagResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tags',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Tag
 *
 * API to delete a tag
 */
export const deleteTag = <ThrowOnError extends boolean = false>(
  options: Options<DeleteTagData, ThrowOnError>
) =>
  (options.client ?? client).delete<DeleteTagResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tags/{tagId}',
    ...options,
  });

/**
 * Get Tag Details
 *
 * API to fetch details of a tag
 */
export const getTagDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetTagDetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<GetTagDetailsResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/tags/{tagId}',
      ...options,
    }
  );

/**
 * Edit Tag
 *
 * API to update the Tag properties
 */
export const editTag = <ThrowOnError extends boolean = false>(
  options: Options<EditTagData, ThrowOnError>
) =>
  (options.client ?? client).patch<EditTagResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tags/{tagId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove objects from Tag
 *
 * API to remove objects from a tag
 * This API takes below request body <br/>
 * [<br/>
 * {<br/>
 * "id": "woC32em2Fb0",<br/>
 * "objectType": "FILE"<br/>
 * }<br/>
 * ]
 */
export const removeobjectsfromTag = <ThrowOnError extends boolean = false>(
  options: Options<RemoveobjectsfromTagData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveobjectsfromTagResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tags/{tagId}/objects',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List objects in a Tag
 *
 * API to list objects mapped to a tag
 */
export const listobjectsinaTag = <ThrowOnError extends boolean = false>(
  options: Options<ListobjectsinaTagData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListobjectsinaTagResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tags/{tagId}/objects',
    ...options,
  });

/**
 * Add objects to Tag
 *
 * API to map objects to a tag
 */
export const addobjectstoTag = <ThrowOnError extends boolean = false>(
  options: Options<AddobjectstoTagData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AddobjectstoTagResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tags/{tagId}/objects',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List all ToDos
 *
 * This API returns the list of todos in a project based on either project Id or file
 * Id using which todos are created.
 */
export const listallToDos = <ThrowOnError extends boolean = false>(
  options: Options<ListallToDosData, ThrowOnError>
) =>
  (options.client ?? client).get<ListallToDosResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/todos',
    ...options,
  });

/**
 * Create a New ToDo
 *
 * You may create a new ToDo using this action.
 * + description (string) - The details of the ToDo
 * + projectId (string) - Project Identifier
 *
 * Optional parameters you can define on creation:
 * - type (follow  BCF 2.0 spec)
 * - title
 * - label
 * - dueDate
 * - percentComplete
 * - status
 * - priority
 * - assignees
 */
export const createaNewToDo = <ThrowOnError extends boolean = false>(
  options: Options<CreateaNewToDoData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateaNewToDoResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/todos',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List all Todo Types of a Project
 *
 * List all Todo Types of a Project
 */
export const listallTodoTypesofaProject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListallTodoTypesofaProjectData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListallTodoTypesofaProjectResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/todos/types',
    ...options,
  });

/**
 * Delete a ToDo
 *
 * Delete a ToDo
 */
export const deleteToDo = <ThrowOnError extends boolean = false>(
  options: Options<DeleteToDoData, ThrowOnError>
) =>
  (options.client ?? client).delete<DeleteToDoResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/todos/{todoId}',
      ...options,
    }
  );

/**
 * Get ToDo Details
 *
 * Get ToDo Details
 */
export const getToDoDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetToDoDetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetToDoDetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/todos/{todoId}',
    ...options,
  });

/**
 * Update ToDo
 *
 * This API allows you to update the following properties of the ToDo:
 *
 * Note : Custom ToDo Label would not be updated from here.
 *
 * - type
 *
 * - title
 *
 * - label
 *
 * - description
 *
 * - dueDate
 *
 * - percentComplete
 *
 * - status
 *
 * - priority
 *
 * - assignees
 */
export const updateToDo = <ThrowOnError extends boolean = false>(
  options: Options<UpdateToDoData, ThrowOnError>
) =>
  (options.client ?? client).patch<UpdateToDoResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/todos/{todoId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove attachments
 *
 * These sets of APIs allow you to remove attachments to a ToDo.
 */
export const removeattachments = <ThrowOnError extends boolean = false>(
  options: Options<RemoveattachmentsData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveattachmentsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/todos/{todoId}/attachments',
    ...options,
  });

/**
 * List all attachments
 *
 * These sets of APIs allow you to list attachments to a ToDo.
 */
export const listallattachments = <ThrowOnError extends boolean = false>(
  options: Options<ListallattachmentsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListallattachmentsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/todos/{todoId}/attachments',
    ...options,
  });

/**
 * Add attachments
 *
 * These sets of APIs allow you to add attachments to a ToDo.
 */
export const addattachments = <ThrowOnError extends boolean = false>(
  options: Options<AddattachmentsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AddattachmentsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/todos/{todoId}/attachments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List All Supported Languages
 *
 * Response is an array of all available Languages supported by Trimble Connect.
 */
export const listAllSupportedLanguages = <ThrowOnError extends boolean = false>(
  options?: Options<ListAllSupportedLanguagesData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListAllSupportedLanguagesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/languages',
    ...options,
  });

/**
 * List User Licenses
 *
 * API to fetch licenses for a current user context
 *
 * An empty object for "license" property indicates that the user does not have any license mapped.
 */
export const listUserLicenses = <ThrowOnError extends boolean = false>(
  options?: Options<ListUserLicensesData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListUserLicensesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/licenses',
    ...options,
  });

/**
 * List All Available Timezones
 *
 * Response is an array of all available Timezones supported by Trimble Connect.
 */
export const listAllAvailableTimezones = <ThrowOnError extends boolean = false>(
  options?: Options<ListAllAvailableTimezonesData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListAllAvailableTimezonesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/timezones',
    ...options,
  });

/**
 * Get User Details
 *
 * Get user details by Trimble Connect user identifier. Use `me` alias (`/users/me`) to get details about the user associated with the passed access token.
 */
export const getUserDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetUserDetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetUserDetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{userId}',
    ...options,
  });

/**
 * Update User Details
 *
 * This API allows you to update the following properties of the User Details:
 *
 * - timeZone
 *
 * - language
 *
 * - phone
 *
 * - podLocation
 *
 * - viewerBackground
 *
 * Supported values for language : [`en-us`,`da-dk`,`de-de`,`es-es`,`fi-fi`,`fr-fr`,`it-it`,`ja-jp`,`ko-kr`,`nb-bo`,`nl-nl`,`pt-br`,`ru-ru`,`sv-se`,`zh-hans`,`zh-hant`]
 */
export const updateUserDetails = <ThrowOnError extends boolean = false>(
  options: Options<UpdateUserDetailsData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateUserDetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{userId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List all View Groups
 *
 * Get the list of all View Groups in a given project.
 */
export const listallViewGroups = <ThrowOnError extends boolean = false>(
  options: Options<ListallViewGroupsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListallViewGroupsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/viewgroups',
    ...options,
  });

/**
 * Create a View Group
 *
 * Create a View Group
 */
export const createaViewGroup = <ThrowOnError extends boolean = false>(
  options: Options<CreateaViewGroupData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateaViewGroupResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/viewgroups',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete a View Group
 *
 * You can use this API to delete a View Group.
 */
export const deleteViewGroup = <ThrowOnError extends boolean = false>(
  options: Options<DeleteViewGroupData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteViewGroupResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/viewgroups/{viewGroupId}',
    ...options,
  });

/**
 * Get View Group Details
 *
 * Get the details of a View Group.
 */
export const getViewGroupDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetViewGroupDetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetViewGroupDetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/viewgroups/{viewGroupId}',
    ...options,
  });

/**
 * Update View Group Details
 *
 * Update the name and views in the View Group. The views list provided in the PATCH Request is applied.
 */
export const updateViewGroupDetails = <ThrowOnError extends boolean = false>(
  options: Options<UpdateViewGroupDetailsData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateViewGroupDetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/viewgroups/{viewGroupId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List all Views in a project
 *
 * This API returns the list of views in a project based on either project Id or file Id using which views are created.
 */
export const listallViewsinaproject = <ThrowOnError extends boolean = false>(
  options: Options<ListallViewsinaprojectData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListallViewsinaprojectResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views',
    ...options,
  });

/**
 * Create View
 *
 * API to create a view. Note that imageData has been truncated in the example below.
 * View can be created on a project level or as view embedded to ToDo. For creating embedded view an todoId property must be given in the Request with valid existing ToDo identifier.
 * **Note:** View models can span up to a limit of **`170`**.
 */
export const createView = <ThrowOnError extends boolean = false>(
  options: Options<CreateViewData, ThrowOnError>
) =>
  (options.client ?? client).post<CreateViewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create View with image
 *
 * Create a view using form data. The form should have two fields; one named view which is the stringified view Json object, the other named imageData is the file to be used as thumbnail.
 *
 * **Note:** View models can span up to a limit of **`170`**.
 */
export const createViewWithThumbnail = <ThrowOnError extends boolean = false>(
  options?: Options<CreateViewWithThumbnailData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    CreateViewWithThumbnailResponses,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/multiparts',
    ...options,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
  });

/**
 * Update View with image
 *
 * Update a view using form data. The form can have two fields; one named view which is the stringified view Json object, the other named imageData is the file to be used as thumbnail.
 * **Note:** View models can span up to a limit of **`170`**.
 */
export const updateViewWithThumbnail = <ThrowOnError extends boolean = false>(
  options: Options<UpdateViewWithThumbnailData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateViewWithThumbnailResponses,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/multiparts/{viewId}',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Delete a View
 *
 * Delete a View
 */
export const deleteView = <ThrowOnError extends boolean = false>(
  options: Options<DeleteViewData, ThrowOnError>
) =>
  (options.client ?? client).delete<DeleteViewResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/views/{viewId}',
      ...options,
    }
  );

/**
 * Get View Details
 *
 * Get View Details
 */
export const getViewDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetViewDetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetViewDetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}',
    ...options,
  });

/**
 * Update a View
 *
 * Update a View
 */
export const updateView = <ThrowOnError extends boolean = false>(
  options: Options<UpdateViewData, ThrowOnError>
) =>
  (options.client ?? client).patch<UpdateViewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Camera Details
 *
 * Get Camera Details
 */
export const getCameraDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetCameraDetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetCameraDetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}/camera',
    ...options,
  });

/**
 * Update Camera
 *
 * Use this API to update a view's camera.  With the exception of the read-only fields: cameraId and viewId, all property could be updated.  For example, to update the up vector, just specify the necessary information the update:
 */
export const updateCamera = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCameraData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateCameraResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}/camera',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get snapshot image for a View
 *
 * Returns the original size snapshot url as uploaded when view was created.
 */
export const getViewImage = <ThrowOnError extends boolean = false>(
  options: Options<GetViewImageData, ThrowOnError>
) =>
  (options.client ?? client).get<GetViewImageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}/image',
    ...options,
  });

/**
 * Upload a Thumbnail Image for a View
 *
 * Upload a Thumbnail Image for a View
 */
export const uploadViewThumbnailImage = <ThrowOnError extends boolean = false>(
  options: Options<UploadViewThumbnailImageData, ThrowOnError>
) =>
  (options.client ?? client).post<
    UploadViewThumbnailImageResponses,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}/image',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * List Markups
 *
 * List Markups
 */
export const listMarkups = <ThrowOnError extends boolean = false>(
  options: Options<ListMarkupsData, ThrowOnError>
) =>
  (options.client ?? client).get<ListMarkupsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}/markups',
    ...options,
  });

/**
 * Update a Markup
 *
 * Update a Markup
 */
export const updateMarkup = <ThrowOnError extends boolean = false>(
  options: Options<UpdateMarkupData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateMarkupResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}/markups',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Markups
 *
 * API to create markups.
 */
export const createMarkups = <ThrowOnError extends boolean = false>(
  options: Options<CreateMarkupsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateMarkupsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}/markups',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete a Markup
 *
 * Delete a Markup
 */
export const deleteMarkup = <ThrowOnError extends boolean = false>(
  options: Options<DeleteMarkupData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteMarkupResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}/markups/{markupId}',
    ...options,
  });

/**
 * Get Presentation
 *
 * Get Presentation
 */
export const getPresentation = <ThrowOnError extends boolean = false>(
  options: Options<GetPresentationData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetPresentationResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}/presentation',
    ...options,
  });

/**
 * Update a Presentation
 *
 * Update a Presentation
 */
export const updatePresentation = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePresentationData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdatePresentationResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}/presentation',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Section Box
 *
 * Delete the view section box
 */
export const deleteSectionBox = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSectionBoxData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteSectionBoxResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}/sectionbox',
    ...options,
  });

/**
 * Get Section Box
 *
 * Use this API to get view section box.
 */
export const getSectionBox = <ThrowOnError extends boolean = false>(
  options: Options<GetSectionBoxData, ThrowOnError>
) =>
  (options.client ?? client).get<GetSectionBoxResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/views/{viewId}/sectionbox',
      ...options,
    }
  );

/**
 * Create or Update Section Box
 *
 * Use this API to create or update a view's section box by supplying the full object in the Request body.
 */
export const updateSectionBox = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSectionBoxData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateSectionBoxResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}/sectionbox',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Section Planes
 *
 * Use this API to get a view section plane.
 */
export const listSectionPlanes = <ThrowOnError extends boolean = false>(
  options: Options<ListSectionPlanesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListSectionPlanesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}/sectionplanes',
    ...options,
  });

/**
 * Update Section Plane
 *
 * Use this API to update a view section plane.
 */
export const updateSectionPlane = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSectionPlaneData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateSectionPlaneResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}/sectionplanes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Section Plane
 *
 * Use this API to add a view section plane. To add a view section plane, supply the full object in the Request body.
 */
export const createSectionPlane = <ThrowOnError extends boolean = false>(
  options: Options<CreateSectionPlaneData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateSectionPlaneResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}/sectionplanes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete a Section Plane
 *
 * Delete a Section Plane
 */
export const deleteSectionPlane = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSectionPlaneData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteSectionPlaneResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}/sectionplanes/{sectionplaneId}',
    ...options,
  });

/**
 * List all 2D Views
 *
 * API to list 2D Views in a project based on either project Id or file Id using which views are created.
 */
export const listall2dViews = <ThrowOnError extends boolean = false>(
  options?: Options<Listall2dViewsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    Listall2dViewsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views2d',
    ...options,
  });

/**
 * Create a New 2D View
 *
 * API to create a new 2D View. Thumbnail data can be attached as base64 encoded format in the Request.
 */
export const createaNew2dView = <ThrowOnError extends boolean = false>(
  options: Options<CreateaNew2dViewData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateaNew2dViewResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views2d',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create a new 2D View with image
 *
 * Create a 2dview using Multipart/form-data media type. The form should have two fields; one named views2d which is the stringified 2dview Json object, the other named imageData is the file to be used as thumbnail.
 */
export const createa2dViewMultipart = <ThrowOnError extends boolean = false>(
  options: Options<Createa2dViewMultipartData, ThrowOnError>
) =>
  (options.client ?? client).post<
    Createa2dViewMultipartResponses,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views2d/multiparts',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Update a 2D View with image
 *
 * Update a 2dview using Multipart/form-data media type. The form can have two fields; one named view which is the stringified view Json object, the other named imageData is the file to be used as thumbnail.
 */
export const update2dViewMultipart = <ThrowOnError extends boolean = false>(
  options: Options<Update2dViewMultipartData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    Update2dViewMultipartResponses,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views2d/multiparts/{viewId}',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Delete 2D View
 *
 * API to delete 2D View by it's id.
 */
export const delete2dView = <ThrowOnError extends boolean = false>(
  options: Options<Delete2dViewData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    Delete2dViewResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views2d/{viewId}',
    ...options,
  });

/**
 * Get 2D View details
 *
 * API to get details of a 2D View by it's Id.
 */
export const get2dViewdetails = <ThrowOnError extends boolean = false>(
  options: Options<Get2dViewdetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    Get2dViewdetailsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views2d/{viewId}',
    ...options,
  });

/**
 * Update 2D View
 *
 * API to update 2D View.
 */
export const update2dView = <ThrowOnError extends boolean = false>(
  options: Options<Update2dViewData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    Update2dViewResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views2d/{viewId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete reserved data for a specific view and app
 */
export const deleteReservedViewData = <ThrowOnError extends boolean = false>(
  options: Options<DeleteReservedViewDataData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteReservedViewDataResponses,
    DeleteReservedViewDataErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}/reserved',
    ...options,
  });

/**
 * Retrieve reserved data for a specific view and app
 */
export const getReservedViewData = <ThrowOnError extends boolean = false>(
  options: Options<GetReservedViewDataData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetReservedViewDataResponses,
    GetReservedViewDataErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}/reserved',
    ...options,
  });

/**
 * Create or update reserved data for a specific view
 */
export const putReservedViewData = <ThrowOnError extends boolean = false>(
  options: Options<PutReservedViewDataData, ThrowOnError>
) =>
  (options.client ?? client).put<
    PutReservedViewDataResponses,
    PutReservedViewDataErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/views/{viewId}/reserved',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
